import React, { useState, useEffect } from 'react';
import './Loading.css';

const Loading = ({ 
  title = "Loading...", 
  subtitle = "...",
  progress = 0,
  status = "loading", // "loading", "success", "error"
  showStats = false
}) => {
  const [loadingPercentage, setLoadingPercentage] = useState(0);

  useEffect(() => {
    if (progress > 0) {
      setLoadingPercentage(progress);
    } else {
      // Simulate loading progress
      const interval = setInterval(() => {
        setLoadingPercentage(prev => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + 1;
        });
      }, 50);
      
      return () => clearInterval(interval);
    }
  }, [progress]);

  return (
    <div className={`loading-container ${status ? `loading-${status}` : ''}`}>
      <div className="loading-content">
        <h2>{title}</h2>
        {/* <p className="loading-subtitle">{subtitle}</p> */}
        
        {/* Truck Wheel Loading Animation */}
        <div className="wheel-loading-container">
          {/* Main Truck Wheel */}
          <div className="loading-wheel">
            <div className="wheel-outer-ring"></div>
            <div className="wheel-tread"></div>
            <div className="wheel-rim"></div>
            <div className="wheel-hub">
              <div className="hub-nut"></div>
            </div>
            <div className="wheel-spokes">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="spoke"></div>
              ))}
            </div>
          </div>
          
          {/* Orbiting Wheels */}
          <div className="orbiting-wheel"></div>
          <div className="orbiting-wheel"></div>
          <div className="orbiting-wheel"></div>
          <div className="orbiting-wheel"></div>
        </div>
        
        {/* Progress Bar with Wheel */}
        <div className="loading-progress-track">
          <div 
            className="loading-progress-fill" 
            style={{ width: `${loadingPercentage}%` }}
          ></div>
          <div className="progress-wheel"></div>
        </div>
        
        {/* Loading Percentage */}
        <div style={{ 
          marginTop: '15px', 
          fontSize: '18px', 
          fontWeight: '600',
          color: '#667eea'
        }}>
          {loadingPercentage}%
        </div>
        
        {/* Loading Dots (Wheel Lug Nuts) */}
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        
        {/* Optional Statistics */}
        {showStats && (
          <div className="loading-stats">
            <div className="loading-stat">
              <span className="loading-stat-value">100%</span>
              <span className="loading-stat-label">Secure</span>
            </div>
            <div className="loading-stat">
              <span className="loading-stat-value">24/7</span>
              <span className="loading-stat-label">Tracking</span>
            </div>
            <div className="loading-stat">
              <span className="loading-stat-value">{loadingPercentage}%</span>
              <span className="loading-stat-label">Loaded</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Loading;